module.exports = __webpack_public_path__ + "img/slika9.584be7eb.jpg";